import * as React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import getCommunityMembersQuery from 'shared/graphql/queries/community/getCommunityMembers';
import { Avatar } from 'src/components/avatar';
import { ErrorBoundary } from 'src/components/error';
import ModalContainer from '../modalContainer';
import { PrimaryButton } from 'src/components/button';
import Tooltip from 'src/components/tooltip';

import { Checkbox } from '../../formElements';
import NextPageButton from 'src/components/nextPageButton';
import {
  Form,
  Actions,
  Label,
  ExpertsBox,
  ExpertsList,
  Expert,
  Info,
  UserName,
  Role,
  StyleCheckbox,
  Description,
  HorizontalLine,
  StyledExpertPill,
} from './style';
import { Roles_Display } from '../../../utils';
import { Loading } from 'src/components/loading';
const DATA_TEST_PRE = 'post-expert-modal-';
const Experts = props => {
  const {
    data,
    isFetchingMore,
    selectedExperts,
    confirm,
    handleExperts,
  } = props;
  const { community } = data;
  const { edges: members } =
    community && community.members ? community.members : { edges: [] };
  const nodes = members.map(member => member && member.node).filter(Boolean);
  const hasNextPage = community?.members.pageInfo.hasNextPage;
  const close = e => {
    confirm();
  };
  const confirmClick = e => {
    e.preventDefault();
    confirm();
  };

  const isAlreadySelected = user => {
    return !!selectedExperts.find(select => select && select.id === user.id);
  };

  const handleCheckboxChange = e => {
    const member = nodes.find(({ user }) => user && user.id === e.target.id);
    if (isAlreadySelected(member.user)) {
      const experts = selectedExperts.filter(
        user => user && user.id !== e.target.id
      );
      handleExperts(experts);
    } else {
      handleExperts([...selectedExperts, member.user]);
    }
  };

  return (
    <>
      {!community && (
        <ModalContainer title={'Choose Experts'} closeModal={close}>
          <Loading />
        </ModalContainer>
      )}
      {community && (
        <ModalContainer title={'Choose Experts'} closeModal={close}>
          {nodes && nodes.length !== 0 ? (
            <Form>
              <Label>
                Choose which of our experts you'd like to answer your question
              </Label>

              <ExpertsList>
                {nodes.map(({ user }) => (
                  <ErrorBoundary key={user.id}>
                    <Expert>
                      <Info>
                        <Avatar
                          showHoverProfile={false}
                          size={35}
                          source={user.profilePhoto}
                          member={user}
                          fontSize={14}
                        />
                        <UserName>
                          {user.firstName && user.lastName
                            ? `${user.firstName} ${user.lastName}`
                            : user.name}
                        </UserName>
                        <Role>
                          {user.primaryRole && Roles_Display[user.primaryRole]}
                          {user.city ? `in ${user.city}` : ''}
                          {user.country ? `in ${user.country}` : ''}
                        </Role>
                        <StyleCheckbox>
                          <Checkbox
                            id={user.id}
                            key={user.id}
                            checked={isAlreadySelected(user)}
                            onChange={handleCheckboxChange}
                            testId={`${DATA_TEST_PRE}select-expert${user.id}`}
                          />
                        </StyleCheckbox>
                      </Info>
                      <Description>{user.description}</Description>
                    </Expert>
                    <HorizontalLine />
                  </ErrorBoundary>
                ))}
                {hasNextPage && (
                  <NextPageButton
                    isFetchingMore={isFetchingMore}
                    fetchMore={props.data.fetchMore}
                    data-testid={`${DATA_TEST_PRE}load-more`}
                  >
                    Load more posts
                  </NextPageButton>
                )}
              </ExpertsList>
              <Label>Selected experts</Label>
              <ExpertsBox>
                {selectedExperts &&
                  selectedExperts.length > 0 &&
                  selectedExperts.map(
                    user =>
                      user && (
                        <Tooltip key={user.id} content={'Delete'}>
                          <StyledExpertPill
                            id={user.id}
                            key={user.id}
                            onClick={e => {
                              handleExperts(
                                selectedExperts.filter(
                                  user => user && user.id !== e.target.id
                                )
                              );
                            }}
                            data-testid={`${DATA_TEST_PRE}remove-expert`}
                          >
                            {user.firstName && user.lastName
                              ? `${user.firstName} ${user.lastName}`
                              : user.name}
                          </StyledExpertPill>
                        </Tooltip>
                      )
                  )}
              </ExpertsBox>
              <Actions>
                <PrimaryButton
                  onClick={confirmClick}
                  data-testid={`${DATA_TEST_PRE}confirm`}
                >
                  CONFIRM
                </PrimaryButton>
              </Actions>
            </Form>
          ) : (
            <Form>
              <Label>
                There's no assigned expert in this groups, please inform the
                group organizer.
              </Label>
              <Actions>
                <PrimaryButton
                  onClick={confirmClick}
                  data-testid={`${DATA_TEST_PRE}confirm`}
                >
                  CONFIRM
                </PrimaryButton>
              </Actions>
            </Form>
          )}
        </ModalContainer>
      )}
    </>
  );
};

export default compose(
  withRouter,
  connect(),
  getCommunityMembersQuery
)(Experts);
